/*
saikrishna 11/03/2022 3075154998 changed the paginationOptions
 */
import React, {createRef} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../../components/TableIcons';
import GuiTable from '../../../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../../../constants/ReusableTablePagination';

export default function ConditionTable({
  conditionData,
  setConditionData,
}) {
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        conditionData[rowData?.tableData?.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'To Field',
      field: 'toField',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
    {
      title: 'Source Field',
      field: 'srcField',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },

    {
      title: 'Operator',
      field: 'operator',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
      render: (rowData) =>
        rowData?.operator?.valueCode && rowData?.operator?.value ?
          `${rowData?.operator?.valueCode} - ${rowData?.operator?.value}` :
          rowData?.operator ?
            rowData?.operator :
            '',
    },
    {
      title: 'Date Format',
      field: 'dateFormat',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
  ];

  const tableRef = createRef();

  const tableDataCondition = conditionData ?
    conditionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];


  return (
    <div className="global-field-table custom-table mb-3">
      <GuiTable
        title=""
        columns={columns}
        icons={tableIcons}
        tableRef={tableRef}
        data={tableDataCondition}
        options={{
          search: false,
          toolbar: false,
          pageSize: defaultRows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
      />
    </div>
  );
}
